import React from 'react';

export default function TermsAndConditions() {
    return (
        <main className="container mx-auto p-6 prose">
            <h1>Términos y Condiciones de Donaciones</h1>
            <p><strong>Última actualización:</strong> 27 de mayo de 2025</p>

            <h2>1. Identificación del Responsable</h2>
            <p>Inspira Cambio A.C., con domicilio en Insurgentes Centro 56 Int. 401 y 402, Col. Tabacalera, Cuauhtémoc, C.P. 06030, Ciudad de México, pone a disposición el presente documento.</p>

            <h2>2. Objeto</h2>
            <p>Regula el acceso, uso y condiciones para realizar donaciones voluntarias en favor de Inspira Cambio A.C.</p>

            <h2>3. Naturaleza de las Donaciones</h2>
            <p>Las donaciones son voluntarias, no reembolsables y se destinan a apoyar programas, servicios de salud, sensibilización y actividades comunitarias.</p>

            <h2>4. Métodos de Pago</h2>
            <ul>
                <li>Tarjetas de crédito o débito (Visa, Mastercard, etc.)</li>
                <li>Transferencias bancarias</li>
                <li>Pagos en efectivo en tiendas de conveniencia (cuando esté disponible)</li>
            </ul>
            <p><strong>Los pagos serán procesados mediante Openpay</strong>, una plataforma segura operada por BBVA. Inspira Cambio A.C. no almacena información financiera de los donantes.</p>

            <h2>5. Confirmación de Donación</h2>
            <p>El donante recibirá un comprobante electrónico al correo proporcionado. Para factura fiscal, enviar datos a <a href="mailto:info@inspiracambio.org">info@inspiracambio.org</a> en un plazo de 5 días hábiles.</p>

            <h2>6. Uso de los Recursos</h2>
            <p>Los fondos se utilizan exclusivamente para el objeto social: servicios de salud sexual, campañas de sensibilización y proyectos comunitarios. Se publicarán reportes periódicos.</p>

            <h2>7. Política de Reembolsos</h2>
            <p>Las donaciones no son reembolsables. Para errores en transacciones, contactar en un plazo de 3 días naturales a <a href="mailto:info@inspiracambio.org">info@inspiracambio.org</a>.</p>

            <h2>8. Protección de Datos Personales</h2>
            <p>Los datos se tratan conforme a nuestro <a href="/privacidad">Aviso de Privacidad</a>, en cumplimiento de la Ley Federal de Protección de Datos Personales.</p>

            <h2>9. Modificaciones</h2>
            <p>Inspira Cambio A.C. puede modificar estos términos. Los cambios se publicarán en <a href="https://dona.inspiracambio.org">dona.inspiracambio.org</a> y redes sociales.</p>
        </main>
    );
}
